import React from 'react';
import { SmartLink } from '../SmartLink';
export function PricingCta() {
  return <section id="get-started" data-nav-theme="dark" className="footer-gradient w-full py-20" aria-labelledby="pricing-cta-heading" data-id="element-1016" data-mp="15hekjqkjc7fw">
      <div className="mx-auto max-w-shell px-6 text-center" data-id="element-1017" data-mp="qttk64f1ombo">
        <h2 id="pricing-cta-heading" className="display text-[32px] font-semibold text-white sm:text-[44px]" data-id="element-1018" data-mp="vrlknmtr9grh">
          Not sure which plan fits?
        </h2>
        <p className="mx-auto mt-5 max-w-[480px] text-[16px] leading-[1.55] text-white/70" data-id="element-1019" data-mp="1ji7fudinv6k2">
          Talk to our team in Kigali and we’ll help you choose the right plan for your business.
        </p>
        <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row" data-id="element-1020" data-mp="19j041urkrjz2">
          <SmartLink href="/demo" className="w-full rounded-[7px] bg-brand px-5 py-3 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-hover sm:w-auto" data-id="element-1021" data-mp="1egrv6mkeb227">
            Book a demo
          </SmartLink>
          <SmartLink href="/get-started" className="w-full rounded-[7px] border border-white/30 px-5 py-3 text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:border-white/60 sm:w-auto" data-id="element-1022" data-mp="9qrhf7axd7oy">
            Get started
          </SmartLink>
        </div>
      </div>
    </section>;
}